<template>
  <div>
    <ejs-dialog
      ref="reservationMoveSelectPopup"
      :header="popupData.title || '선택예약이동'"
      :allowDragging="true"
      :showCloseIcon="true"
      :width="popupDialogWidth"
      height="800"
      :animationSettings="{ effect: 'None' }"
      :isModal="true"
      :close="onReservationMoveSelectPopupClosed"
    >
      <div class="window reservationMoveSelect">
        <div class="windowContent">
          <div class="content-wrapper">
            <div class="content-lookup">
              <div class="lookup-left">
                <ul class="lookup-condition">
                  <li class="field">
                    <div class="title">예약일자</div>
                    <ul class="content">
                      <li class="item date">
                        <input-date
                          v-model="moveOption.resveDate"
                          type="lookup-condition"
                          :notClear="true"
                          @change="search"
                        />
                      </li>
                    </ul>
                  </li>
                </ul>
                <div class="lookup-lookup">
                  <erp-button
                    button-div="GET"
                    :is-shortcut-button="true"
                    @click.native="search"
                  >
                    조회
                  </erp-button>
                </div>
              </div>
            </div>
            <div class="content-body">
              <article class="body-article">
                <!-- 이동 대상 요약 -->
                <section class="article-section section-01">
                  <div class="section-body">
                    <div class="body-box">
                      <ul>
                        <li>단체명 : {{ popupData.grpName }}</li>
                        <li>예약자명 : {{ popupData.resveName }}</li>
                        <li>이동 팀수 : {{ teamCount }}팀</li>
                        <li>지정 : {{ assignedCount }} / {{ teamCount }}</li>
                      </ul>
                      <ul>
                        <li>현재 : {{ originSummary }}</li>
                      </ul>
                    </div>
                  </div>
                </section>
                <!-- 이동할 타임 선택 -->
                <section class="article-section section-02">
                  <div class="section-header">
                    <div class="header-left">
                      <div class="header-title">
                        이동할 타임 선택
                      </div>
                    </div>
                    <div class="header-right">
                      <div class="header-caption">
                        아래 미리보기에서 옮길 예약을 고른 뒤 타임을 클릭하세요
                      </div>
                    </div>
                  </div>
                  <div
                    class="section-body"
                    :class="reservationCourseSectionBodyClassName"
                  >
                    <ejs-grid-wrapper
                      v-for="(
                        timeTableCourse, timeTableCourseIdx
                      ) in reservationPossibleTimeCourseLists"
                      :key="timeTableCourse.resveCourseCode"
                      ref="moveReservationGrid"
                      :style="widthBox"
                      :provides="moveReservationGridProvides"
                      :columns="courseGridColumns[timeTableCourseIdx]"
                      :dataSource="timeTableCourse.reservationPossibleTimeLists"
                      :selectionSettings="selectionSettings"
                      :editSettings="editSettings"
                      :allowResizing="true"
                      :allowSelection="true"
                      :allowFiltering="false"
                      :allowSorting="false"
                      :isAutoSelectRow="false"
                      :isAutoSelectCell="false"
                      :isSelectedRowRetain="false"
                      @headerCellInfo="moveReservationHeaderCellInfo"
                      @queryCellInfo="targetTimeQueryCellInfo"
                      @rowSelected="onTargetTimeClicked($event, timeTableCourseIdx)"
                    />
                  </div>
                </section>
                <!-- 이동 미리보기 -->
                <section class="article-section section-03">
                  <div class="section-header">
                    <div class="header-left">
                      <div class="header-title">이동 미리보기</div>
                    </div>
                  </div>
                  <div class="section-body">
                    <ejs-grid-wrapper
                      ref="movePreviewGrid"
                      :provides="movePreviewGridProvides"
                      :columns="movePreviewGridColumns"
                      :dataSource="movePreviewRecords"
                      :allowResizing="true"
                      :allowSelection="true"
                      :isAutoSelectRow="false"
                      @rowSelected="onPreviewRowSelected"
                    />
                  </div>
                </section>
              </article>
            </div>
          </div>
        </div>
        <div class="windowFooter">
          <ul class="button">
            <li class="save keyColor">
              <erp-button
                button-div="SAVE"
                @click.native="saveReservationMoveSelectPopup()"
              >
                선택이동
              </erp-button>
            </li>
            <li class="close">
              <erp-button
                button-div="CLOSE"
                @click.native="closeReservationMoveSelectPopup()"
              >
                닫기
              </erp-button>
            </li>
          </ul>
        </div>
      </div>
    </ejs-dialog>
  </div>
</template>

<script>
import commonMixin from "@/views/layout/mixin/commonMixin";
import confirmDialogMixin from "@/views/layout/mixin/messagePopupDialogMixin";
import { Edit, Resize, ForeignKey } from "@syncfusion/ej2-vue-grids";
import { sortBy as _sortBy } from "lodash";

import { getDayOfWeekAndCaption } from "@/utils/date";
import {
  commonCodesGetComName,
  commonCodesGetCommonCode,
} from "@/utils/commonCodes";
import { getReservationPossibleTimeList } from "@/api/reservation";
import EjsGridWrapper from "@/components/common/EjsGridWrapper";
import { reservationCourseGridSectionBodyClassName } from "@/utils/gridUtil";
import InputDate from "@/components/common/datetime/InputDate";
import GolfErpAPI from "@/api/v2/GolfErpAPI";
import ErpButton from "@/components/button/ErpButton.vue";

export default {
  name: "ReservationMoveSelectPopup",
  mixins: [commonMixin, confirmDialogMixin],
  components: {
    EjsGridWrapper,
    InputDate,
    ErpButton,
  },
  data: function () {
    return {
      popupDialogWidth: null,
      // { title, grpName, resveName, resveNo, timeLists: [ 이동할 예약타임 목록 ] }
      // title 은 호출한 버튼(선택예약이동 / 일괄예약이동)에 따라 달라진다.
      popupData: {
        title: null,
        grpName: null,
        resveName: null,
        resveNo: null,
        timeLists: [],
      },
      moveOption: {
        resveDate: null,
      },
      reservationPossibleTimeCourseLists: [],
      // 원본 timeId -> 지정한 대상 타임. 미리보기에서 고른 행에 하나씩 꽂는다.
      targetTimeByOriginId: {},
      // 미리보기에서 선택한 원본 타임. 이게 있어야 타임 클릭이 배정으로 이어진다.
      selectedOriginTimeId: null,
      selectionSettings: {
        type: "Single",
        mode: "Row",
        enableToggle: false,
      },
      editSettings: {
        mode: "Batch",
        allowEditing: false,
        allowAdding: false,
        allowDeleting: false,
      },
      // 그리드에 넘기는 provides/columns 는 참조가 바뀌면 그리드가 통째로 다시 그려진다.
      // 매 렌더마다 새로 만들지 않도록 고정 참조로 들고 있는다.
      moveReservationGridProvides: [Edit, Resize, ForeignKey],
      movePreviewGridProvides: [Resize],
      courseDivColumns: [
        {
          field: "resveDate",
          allowEditing: false,
          headerText: "일자",
          type: "string",
          minWidth: 16,
          width: 90,
          textAlign: "center",
        },
        {
          field: "dwName",
          allowEditing: false,
          headerText: "요일",
          type: "string",
          minWidth: 16,
          textAlign: "center",
        },
        {
          field: "partDiv",
          allowEditing: false,
          headerText: "부",
          type: "string",
          minWidth: 16,
          width: 60,
          textAlign: "center",
          isCommonCodeField: true,
          groupCode: "PART_DIV",
        },
        {
          field: "resveTime",
          allowEditing: false,
          headerText: "시간",
          type: "string",
          minWidth: 16,
          width: 90,
          textAlign: "center",
        },
      ],
    };
  },
  computed: {
    widthBox() {
      return `width:calc((100%/${this.reservationPossibleTimeCourseLists.length}) + 2px) !important`;
    },
    reservationCourseSectionBodyClassName() {
      return reservationCourseGridSectionBodyClassName(
        this.reservationPossibleTimeCourseLists,
        this.$t("className.reservation.reservationCourseNumPrefix")
      );
    },
    // 코스 목록이 바뀔 때만 다시 만든다. 지정할 때마다 새 배열이 넘어가면
    // Syncfusion 이 컬럼을 재생성하면서 그리드가 다시 그려진다.
    courseGridColumns() {
      return (this.reservationPossibleTimeCourseLists || []).map((course) => [
        {
          headerText: `${course.resveCourseName}코스`,
          columns: JSON.parse(JSON.stringify(this.courseDivColumns)),
          textAlign: "center",
        },
      ]);
    },
    // 미리보기 행 순서. 행 순번이 유지돼야 지정 후에도 선택한 행이 그대로 남는다.
    originTimes() {
      return _sortBy(this.popupData.timeLists || [], [
        "resveCourse",
        "resveDate",
        "resveTime",
      ]);
    },
    teamCount() {
      return this.originTimes.length;
    },
    assignedCount() {
      return this.movePairs.filter((pair) => pair.target).length;
    },
    // 이미 다른 원본에 배정된 타임. 중복 지정을 막고 색으로 표시하는 데 쓴다.
    assignedTargetTimeIds() {
      return this.originTimes
        .map((origin) => this.targetTimeByOriginId[origin.timeId])
        .filter(Boolean)
        .map((target) => target.timeId);
    },
    originSummary() {
      if (this.originTimes.length === 0) {
        return "";
      }

      return this.originTimes
        .map((timeInfo) => this.buildTimeCaption(timeInfo))
        .join(" / ");
    },
    movePairs() {
      return this.originTimes.map((origin) => ({
        origin: origin,
        target: this.targetTimeByOriginId[origin.timeId] || null,
      }));
    },
    movePreviewRecords() {
      // 지정 전에도 원본 N 행은 보이게 두고, 지정하는 만큼 "이동 후" 가 채워진다.
      // NO 컬럼은 EjsGridWrapper 가 자동으로 붙여준다.
      return this.movePairs.map((pair) => ({
        originTimeId: pair.origin.timeId,
        fromCaption: this.buildTimeCaption(pair.origin),
        toCaption: pair.target ? this.buildTimeCaption(pair.target) : "",
      }));
    },
    movePreviewGridColumns() {
      return [
        {
          field: "fromCaption",
          headerText: "현재",
          type: "string",
          minWidth: 16,
          textAlign: "center",
        },
        {
          field: "toCaption",
          headerText: "이동 후",
          type: "string",
          minWidth: 16,
          textAlign: "center",
        },
      ];
    },
  },
  created: function () {
    const courseCodes = commonCodesGetCommonCode("COURSE_CODE", true);

    this.popupDialogWidth = Math.round(440 * courseCodes.length);
  },
  methods: {
    getDayOfWeekAndCaption: getDayOfWeekAndCaption,
    commonCodesGetComName: commonCodesGetComName,
    buildTimeCaption(timeInfo) {
      if (!timeInfo) {
        return "";
      }

      return `${commonCodesGetComName(
        "COURSE_CODE",
        timeInfo.resveCourse
      )} ${timeInfo.resveDate} ${timeInfo.resveTime}`;
    },
    moveReservationHeaderCellInfo(args) {
      if (args.cell.column.headerText === "NO") {
        args.node.classList.add(this.$t("className.grid.noSortFilter"));
      }
    },
    popupOpen: function (popupData, resveDate) {
      this.popupData = popupData;
      this.moveOption.resveDate = resveDate;

      this.search();
      this.$refs.reservationMoveSelectPopup.show();
    },
    closeReservationMoveSelectPopup: function () {
      this.$refs.reservationMoveSelectPopup.hide();
    },
    onReservationMoveSelectPopupClosed: function () {
      this.$emit("popupClosed");
    },
    search: function () {
      // 조회한 타임이 바뀌면 지정해 둔 대상도 의미가 없어진다.
      this.targetTimeByOriginId = {};

      getReservationPossibleTimeList(
        this.moveOption.resveDate,
        this.moveOption.resveDate
      )
        .then((response) => {
          this.reservationPossibleTimeCourseLists =
            response.value.reservationPossibleTimeCourseLists;
        })
        .catch((error) => {
          console.log("getReservationPossibleTimeList.err.===>", error);
        });
    },
    // 미리보기에서 고른 행이 "지금 지정할 원본" 이 된다.
    onPreviewRowSelected(args) {
      this.selectedOriginTimeId = args?.data?.originTimeId ?? null;
    },
    // 코스 그리드의 타임을 클릭하면 선택된 미리보기 행에 배정한다.
    onTargetTimeClicked(args, courseIdx) {
      const timeInfo = args?.data;

      // 클릭을 배정 트리거로만 쓴다. 선택이 남아 있으면 같은 행을 다시 클릭해도
      // rowSelected 가 오지 않아 해제가 안 되므로 매번 비운다.
      this.$nextTick(() => {
        const grid = (this.$refs.moveReservationGrid || [])[courseIdx];

        if (grid) {
          grid.clearSelection();
        }
      });

      if (!timeInfo || timeInfo.timeId === null || timeInfo.timeId === undefined) {
        return;
      }

      if (!this.selectedOriginTimeId) {
        this.infoToast("이동할 예약을 미리보기에서 먼저 선택해 주십시오");
        return;
      }

      const currentTarget = this.targetTimeByOriginId[this.selectedOriginTimeId];

      // 이미 이 행에 지정된 타임을 다시 누르면 지정 해제
      if (currentTarget && currentTarget.timeId === timeInfo.timeId) {
        this.$delete(this.targetTimeByOriginId, this.selectedOriginTimeId);
        this.refreshTargetTimeGrids();
        return;
      }

      if (this.assignedTargetTimeIds.includes(timeInfo.timeId)) {
        this.infoToast("이미 다른 예약에 지정된 타임입니다");
        return;
      }

      this.$set(this.targetTimeByOriginId, this.selectedOriginTimeId, timeInfo);
      this.refreshTargetTimeGrids();
    },
    // 지정 표시(배경색)는 queryCellInfo 로 그리므로 다시 그려야 반영된다.
    refreshTargetTimeGrids() {
      this.$nextTick(() => {
        (this.$refs.moveReservationGrid || []).forEach((grid) => {
          grid.refresh();
        });
      });
    },
    targetTimeQueryCellInfo(args) {
      if (this.assignedTargetTimeIds.includes(args.data.timeId)) {
        args.cell.style.backgroundColor = "#fff2cc";
      }
    },
    async saveReservationMoveSelectPopup() {
      if (this.teamCount === 0) {
        this.errorToast("이동할 예약 타임이 없습니다");
        return;
      }

      const pairs = this.movePairs;

      if (pairs.some((pair) => !pair.target)) {
        this.errorToast(
          `이동할 타임을 모두 지정해 주십시오 ` +
            `(${this.assignedCount} / ${this.teamCount})`
        );
        return;
      }

      // 동반자 수가 대상 타임의 내장인원을 넘으면 서버에서 거부된다.
      // 예약가능타임 조회 응답에는 내장인원이 없어 여기서는 미리 막지 못한다.
      if (!(await this.confirm(`${this.teamCount}팀을 이동하시겠습니까?`))) {
        return;
      }

      const moves = pairs.map((pair) => ({
        existTimeId: pair.origin.timeId,
        existOptFlag: pair.origin.optFlag,
        existResveDate: pair.origin.resveDate,
        moveTimeId: pair.target.timeId,
        moveOptFlag: pair.target.optFlag,
        moveResveDate: pair.target.resveDate,
      }));

      await GolfErpAPI.reservationTimeMoveSelect({ moves });

      // 이동한 첫 타임 기준으로 호출부가 상세를 다시 연다 (예약이동/일괄예약이동과 동일)
      this.$emit("popupClosed", { isReload: true, time: pairs[0].target });
      this.$refs.reservationMoveSelectPopup.hide();
    },
  },
};
</script>

<style scoped>
/*
  공통 CSS(window.lazy.css)는 팝업 window 클래스별로 규칙을 들고 있는데,
  이 팝업은 그쪽에 블록을 만들지 않고 여기서 직접 잡는다.

  - .article-section 에 height:100% 가 걸려 있어, 한 article 에 섹션이 3개면
    높이가 안 잡혀 그리드가 렌더되지 않는다. 섹션별 높이를 지정한다.
  - 코스 그리드는 .body-grid(EjsGridWrapper 루트)를 float 시켜 가로로 나열한다.
    float 만으로는 부모 높이가 죽으므로 :after 로 clear 한다.
*/
body .window.reservationMoveSelect .windowContent .article-section.section-01 {height: auto;}
body .window.reservationMoveSelect .windowContent .article-section.section-01 .section-body {overflow: visible; border: none;}
body .window.reservationMoveSelect .windowContent .article-section.section-01 .body-box {padding: 6px 0; color: #000; background-color: #f9f9f9;}
body .window.reservationMoveSelect .windowContent .article-section.section-01 .body-box ul {display: block; list-style: none; padding: 0; margin: 0;}
@supports (display: flow-root) {body .window.reservationMoveSelect .windowContent .article-section.section-01 .body-box ul {display: flow-root;}}
body .window.reservationMoveSelect .windowContent .article-section.section-01 .body-box ul:after {display: block; clear: both; height: 0; font-size: 0; line-height: 0; content: '';}
body .window.reservationMoveSelect .windowContent .article-section.section-01 .body-box ul li {float: left; padding: 3px 12px 3px 13px; margin: 0 0 -1px 0; background: transparent url("~@/assets/images/common/division.png") no-repeat left center;}
body .window.reservationMoveSelect .windowContent .article-section.section-01 .body-box ul li:first-child {padding: 3px 12px; background: none;}

body .window.reservationMoveSelect .windowContent .article-section.section-02 {height: calc(100% - 76px - 220px);}
body .window.reservationMoveSelect .windowContent .article-section.section-02 .section-body {display: block; overflow: hidden; border: none; padding: 0 1px;}
@supports (display: flow-root) {body .window.reservationMoveSelect .windowContent .article-section.section-02 .section-body {display: flow-root;}}
body .window.reservationMoveSelect .windowContent .article-section.section-02 .section-body:after {display: block; clear: both; height: 0; font-size: 0; line-height: 0; content: '';}
body .window.reservationMoveSelect .windowContent .article-section.section-02 .section-body .body-grid {position: relative; float: left; width: calc(100% + 2px); margin: 0 -1px;}
body .window.reservationMoveSelect .windowContent .article-section.section-02 .section-body.dev-reservation-course-num-4 .body-grid {width: calc((100% / 4) + 2px);}
body .window.reservationMoveSelect .windowContent .article-section.section-02 .section-body.dev-reservation-course-num-3 .body-grid {width: calc((100% / 3) + 2px);}
body .window.reservationMoveSelect .windowContent .article-section.section-02 .section-body.dev-reservation-course-num-2 .body-grid {width: calc((100% / 2) + 2px);}
/* 그리드 내부(Syncfusion 이 그리는 DOM)는 scoped 속성이 안 붙어 ::v-deep 가 필요하다 */
body .window.reservationMoveSelect .windowContent .article-section.section-02 .body-grid ::v-deep .e-grid.e-lib .e-gridheader {border-top-color: #ccc;}

body .window.reservationMoveSelect .windowContent .article-section.section-03 {height: 220px;}
body .window.reservationMoveSelect .windowContent .article-section.section-03 .section-body {overflow: hidden; border: none; padding: 0 1px;}
</style>
